/**
 * Base type for service configuration options
 */
export type ServiceConfig = Record<string, any>;

/**
 * Service status enumeration for tracking service lifecycle states
 */
export enum ServiceStatus {
  UNINITIALIZED = 'uninitialized',
  INITIALIZING = 'initializing',
  READY = 'ready',
  ERROR = 'error'
}
